/*
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
*/

// IP-NOTICE: CUSTOM
import { Component, Input } from '@angular/core';
import { OrbitTableConfig } from 'app/shared/components/orbit-table/orbit-table.models';


@Component({
    selector: 'basic-payment-list',
    templateUrl: './payment-list.component.html',
    styleUrls: ['./payment-list.component.scss'],
    standalone: false,
})
export class BasicPaymentListComponent {
  
   @Input() payments = [];

  readonly tableConfig: OrbitTableConfig<any> = {
    ariaLabel: 'Payments', dashboard: false,
    columns: [
      { key: 'description', label: 'Description', value: row => row.description, width: '230px', tooltip: true, sortable: false, footerValue: 'Total' },
      {
        key: 'paymentAmount',
        label: 'Amount (£)',
        value: row => row.amount,
        width: '170px',
        align: 'right',
        sortable: false,
        footerValue: rows => rows.reduce((sum, row) => sum + (Number(row?.amount) || 0), 0),
        footerFormat: value => this.footerNumberFormatter.format(Number(value) || 0),
      },
      { key: 'paymentDate', label: 'Date', value: row => row.paymentDate, width: '180px', sortable: false },
    ],
    rowHover: true,
    selection: { mode: 'disabled', rowId: row => row.id ?? `${row.description}-${row.paymentDate}-${row.amount}` },
    sorting: { enabled: false }, pagination: { enabled: false },
    footer: { enabled: true, sticky: true },
    scroll: { stickyHeader: true, minWidth: '580px' },
    resultSummary: { visible: false, businessObjectName: 'Payment', businessObjectNamePlural: 'Payments' },
    state: { emptyTitle: 'No payments found' },
  };

  private readonly footerNumberFormatter = new Intl.NumberFormat('en-GB', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
 
}